export default {
  emits: ['applyFilters', 'change'],

  mounted() {
    document.body.addEventListener('keyup', this.hidePopoverOnEsc)
  },

  unmounted() {
    document.body.removeEventListener('keyup', this.hidePopoverOnEsc)
  },

  methods: {
    viewSearchResults(filters) {
      this.$emit('applyFilters', filters)
      this.$refs.filter_popover.hide()
    },

    changedFilterValue(filterList) {
      this.$emit('change', filterList)
    },

    hidePopoverOnEsc(e) {
      if (e.key === 'Escape' && this.$refs.filter_popover) {
        this.$refs.filter_popover.hide()
      }
    }
  }
}
